import React, { forwardRef, useEffect, useState } from 'react';
import ProgressBar from '../ProgressBar/ProgressBar';
import { translate } from '../../Services/translation';
import clsx from 'clsx';

interface LoadMoreButtonAttributes
  extends React.HTMLAttributes<HTMLDivElement> {
  disabled?: boolean;
  count?: number;
  totalCount?: number;
  isLoading?: boolean;
  productsPerLoad?: number;
  location?: string;
  pageNumberForCrawler: number;
  pageSize: number;
  canLoadMore?: boolean;
  onClick: () => void;
}

const LoadMoreButton = forwardRef<
  HTMLDivElement,
  LoadMoreButtonAttributes
>(
  (
    {
      onClick,
      disabled = false,
      count,
      totalCount,
      isLoading = false,
      productsPerLoad,
      location,
      pageNumberForCrawler,
      canLoadMore,
      pageSize,
      ...props
    }: LoadMoreButtonAttributes,
    wrapperRef
  ) => {
    return (
      <div
        {...props}
        className={clsx(
          props.className,
          'mx-auto my-0 flex max-w-[240px] flex-col pt-4 md:pt-6'
        )}
        ref={wrapperRef}
      >
        {/* Anchor tag with a link to support crawlers */}
        {canLoadMore && count !== totalCount && (
          <a
            className={clsx(
              'btn btn--inverted-outline btn--large w-full text-center',
              disabled && 'disabled'
            )}
            onClick={(e) => {
              if (onClick) {
                e.preventDefault();
                onClick();
              }
            }}
            href={`${location}?page=${pageNumberForCrawler}`}
          >
            {count == totalCount
              ? translate('general.loading.done')
              : isLoading
              ? translate('general.loading') + '...'
              : translate('general.load-more')}
          </a>
        )}
        <ProgressBar progress={count} maxProgress={totalCount} />
      </div>
    );
  }
);

LoadMoreButton.displayName = 'LoadMoreButton';

export default LoadMoreButton;
